export const AUTHORIZED_USERS = [
  { name: "sanket", email: "sanket@nyuctech.com" },
  { name: "pankaj", email: "pankaj@nyuctech.com" },
  { name: "anushka rawat", email: "anushka.rawat@nyuctech.com" },
  { name: "harshel", email: "harshel@nyuctech.com" },
  { name: "Ritesh Mohan Idnani", email: "ritesh.idnani@firstsource.com" },
  { name: "Hasit Trivedi", email: "hasit.trivedi@firstsource.com" },
  { name: "Sundara Sukavanam", email: "sundara.sukavanam@firstsource.com" },
  { name: "Sohit Brahmawar", email: "sohit.brahmawar@firstsource.com" },
  { name: "Arjun Mitra", email: "arjun.mitra@firstsource.com" },
  { name: "Dinesh Jain", email: "dinesh.jain@firstsource.com" },
  { name: "Shamita Mukherjee", email: "shamita.mukherjee@firstsource.com" },
  { name: "Matthew C Barlow", email: "matthew.barlow@firstsource.com" },
  { name: "Scott A Schrader", email: "scott.schrader@firstsource.com" },
  { name: "Vivek Sharma", email: "vivek.sharma@firstsource.com" },
  { name: "Aniket Maindarkar", email: "aniket.maindarkar@firstsource.com" },
  { name: "Rajpal Singh", email: "rajpal.singh1@firstsource.com" },
  { name: "Roshan Halwai", email: "roshan.halwai@firstsource.com" },
  { name: "Ayan Chakraborty", email: "ayan.chakraborty@firstsource.com" },
  { name: "Vivek Irudayaraj", email: "vivek.irudayaraj@firstsource.com" },
  { name: "Kumaran Shanmuhan", email: "kumaran.shanmuhan@firstsource.com" },
  { name: "Giridhar Rangachari", email: "giridar.rangachari@firstsource.com" },
  { name: "Shahul Karim", email: "shahul.karim@firstsource.com" },
  { name: "Sayantan Sengupta", email: "sayantan.sengupta@firstsource.com" },
  { name: "Harry Jose", email: "harry.jose@firstsource.com" },
  { name: "Cyrus Rusi Shroff", email: "cyrus.shroff@firstsource.com" },
  { name: "Manish Bararia", email: "manish.bararia@firstsource.com" },
  { name: "Deepak Kolambkar", email: "deepak.kolambkar@firstsource.com" },
  { name: "Aditi Gujral", email: "aditi.gujral@firstsource.com" },
  { name: "Deepinder Bhatia", email: "deepinder.bhatia@firstsource.com" },
  {
    name: "Hameed Shareef Khaji Shaik",
    email: "hameed.shareef@firstsource.com",
  },
  { name: "Vishal Venkat Rao", email: "vishal.rao1@firstsource.com" },
  { name: "Anita Geoghegan", email: "anita.barnard@firstsource.com" },
  { name: "Jashoo Deyanda Muddappa", email: "jashoo.dm@firstsource.com" },
  {
    name: "Srikrishnan Srinivasa Varadharajan",
    email: "srikrishnan.srinivasa@firstsource.com",
  },
  { name: "Manjunath Srivatsa", email: "manjunath.srivatsa@firstsource.com" },
  { name: "Digvijay Negi", email: "digvijay.negi@firstsource.com" },
  { name: "Noubar Assadourian", email: "noubar.assadourian@firstsource.com" },
  { name: "Murali G", email: "murali.gopalakrishnan@firstsource.com" },
  { name: "Nitu Sarag", email: "nitu.sarag@firstsource.com" },
  {
    name: "Ravishankar Chandran",
    email: "ravishankar.chandran@firstsource.com",
  },
  { name: "Sameer Babu", email: "sameer.babu@firstsource.com" },
  { name: "Tanvi Sharma", email: "tanvi.sharma@firstsource.com" },
  { name: "George Payikad", email: "george.payikad@firstsource.com" },
  { name: "Rohit Sant", email: "rohit.sant@firstsource.com" },
  {
    name: "Arunava Bhattacharjee",
    email: "arunava.bhattacharjee@firstsource.com",
  },
  { name: "Noel A Felipe", email: "noel.felipe@firstsource.com" },
  { name: "Nathan M Allen", email: "nathan.allen@firstsource.com" },
  { name: "Amar Sham Akatrai", email: "amar.akatrai@firstsource.com" },
  { name: "Srinivas Vadlamani", email: "srinivas.vadlamani@firstsource.com" },
  { name: "Richard Anderson", email: "richard.anderson@ascensos.com" },
  { name: "David Gilfillan", email: "david.gilfillan1@firstsource.com" },
  { name: "Vijaya Das Vemmanath", email: "vijay.das@firstsource.com" },
  { name: "Stephen Pascoe", email: "stephen.pascoe@ascensos.com" },
  { name: "ANITHA BALASUBRAMANIAN", email: "anitha.bala@firstsource.com" },
  { name: "Himani Babbar", email: "himani.babbar@firstsource.com" },
  { name: "Rajeev Dhawan", email: "rajeev.dhawan@firstsource.com" },
  { name: "Namish Gulati", email: "namish.gulati@firstsource.com" },
  { name: "Kim R Bozeman", email: "kim.bozeman2@firstsource.com" },
  { name: "Stacy Lawlor", email: "stacy.lawlor@firstsource.com" },
  { name: "Madhavi Behl", email: "madhavi.behl@firstsource.com" },
  { name: "Deepak Gunalan", email: "deepak.gunalan@firstsource.com" },
  { name: "Anand Periyur Thangavel", email: "anand.pt@firstsource.com" },
  { name: "Nupur Jain", email: "nupur.jain1@firstsource.com" },
  { name: "Amrit Khandelwal", email: "amrit.khandelwal@firstsource.com" },
  { name: "Sanjeet Bhabra", email: "sanjeet.bhabra@firstsource.com" },
  { name: "Raghunathan N S", email: "raghunathan.nerur@firstsource.com" },
  { name: "Richa Sethi", email: "richa.sethi@firstsource.com" },
  { name: "Anupam Moitra", email: "anupam.moitra@firstsource.com" },
  { name: "Giridharan T S", email: "giri.tiru@firstsource.com" },
  { name: "Elena Alina Bordeianu", email: "elena.iacob@ascensos.com" },
  {
    name: "Sajan Kumar Chaturvedi",
    email: "sajjan.chaturvedi@firstsource.com",
  },
  { name: "Rahul Agarwal", email: "rahul.agarwal@firstsource.com" },
  { name: "Sameer Ahuja", email: "sameer.ahuja@firstsource.com" },
  { name: "Vimal Nagarajan", email: "vimal.nagarajan@firstsource.com" },
  { name: "Ashwin Kumar Rajput", email: "ashwin.rajput@firstsource.com" },
  { name: "Sanjeev Vimalchandra Jain", email: "sanjeev.jain@firstsource.com" },
  { name: "Vinit Engineer", email: "vineet.engineer@firstsource.com" },
  { name: "Padmini K R", email: "padmini.rathnam@firstsource.com" },
  { name: "Priya Thiagarajan", email: "priya.thiagarajan@firstsource.com" },
  { name: "Vijay Gugnani", email: "vijay.gugnani@firstsource.com" },
  { name: "Ramesh Yechangunja", email: "ramesh.yechangunja@firstsource.com" },
  { name: "Bikash Biyala", email: "bikash.biyala@firstsource.com" },
  { name: "Manish Jain", email: "manish.jain1@firstsource.com" },
  {
    name: "Rajkumar Ramakrishnan",
    email: "rajkumar.ramakrishnan@firstsource.com",
  },
  { name: "Ankit Rathi", email: "ankit.rathi@firstsource.com" },
  {
    name: "Dipti Satishkumar Naidu",
    email: "diptisatishkumar.naidu@firstsource.com",
  },
  { name: "Kunal Agrawal", email: "kunal.agrawal@firstsource.com" },
  {
    name: "Gowrish Prabhu Matti",
    email: "gowrish.prabhumatti@firstsource.com",
  },
  { name: "Himanshu Bathla", email: "himanshu.bathla@firstsource.com" },
  { name: "Vivek Kumar Verma", email: "vivek.verma2@firstsource.com" },
  { name: "Valentina Holguin", email: "valentina.holguin@firstsource.com" },
  { name: "Vishal Gulati", email: "vishal.gulati@firstsource.com" },
  { name: "Pradeesh Prasad", email: "pradeesh.prasad@firstsource.com" },
  { name: "Amy Sue Moored", email: "amy.moored@firstsource.com" },
  {
    name: "Govindaraj Munuswamy",
    email: "govindaraj.munuswamy@firstsource.com",
  },
  {
    name: "Lokeshwaran Thanigachalam Kumar",
    email: "lokeshwaran.tk@firstsource.com",
  },
  { name: "Darrell R Neitzel", email: "darrell.neitzel@firstsource.com" },
  {
    name: "Ravinder Subramanian",
    email: "ravinder.subramanian@firstsource.com",
  },
  { name: "Mohan Acharya", email: "mohan.acharya@firstsource.com" },
  { name: "Michelle Escandell", email: "michelle.escandell@firstsource.com" },
  { name: "Suraj Saripella", email: "suraj.saripella@firstsource.com" },
  { name: "Shivkumar Bellie", email: "shivkumar.bellie@firstsource.com" },
  { name: "Meghna Kenneth Phillip", email: "meghna.phillip@firstsource.com" },
  {
    name: "Natasha K. Sharangdhar",
    email: "natasha.sharangdhar@firstsource.com",
  },
  { name: "Prabhu Sethuraman", email: "prabhu.sethuraman@firstsource.com" },
  { name: "Harendra Singh Rathore", email: "harendra.rathore@firstsource.com" },
  { name: "Ramesh V Shankar", email: "ramesh.shankar1@firstsource.com" },
  { name: "Alok Kumar", email: "alok.kumar@firstsource.com" },
  { name: "Abhay Jugalkishore Pareek", email: "abhay.pareek@firstsource.com" },
  { name: "William Carson", email: "william.carson@firstsource.com" },
  { name: "Vishal Ashok Malu", email: "vishal.malu@firstsource.com" },
  { name: "Roshan Williams", email: "roshan.williams@firstsource.com" },
  { name: "Jayanth Sv", email: "jayanth.sv@firstsource.com" },
  { name: "Annie Emil", email: "annie.emil@firstsource.com" },
  { name: "Sanjay Kumar Gupta", email: "sanjaykumar.gupta@firstsource.com" },
  { name: "Tarik Aboussir", email: "tarik.aboussir@firstsource.com" },
  {
    name: "Jaipal Singh Ahluwalia",
    email: "jaipalsingh.ahluwalia@firstsource.com",
  },
  { name: "Anthony J Balon", email: "anthony.balon@firstsource.com" },
  { name: "Rachel Savage", email: "rachel.savage@firstsource.com" },
  { name: "Mahesh Shenoi", email: "mahesh.shenoi@firstsource.com" },
  { name: "Audrey Harden", email: "audrey.harden@firstsource.com" },
  { name: "James Pilade Garrett", email: "james.garrett@firstsource.com" },
  { name: "Cristina L Velazquez", email: "cristina.mota@firstsource.com" },
  { name: "Robert N Palinsky", email: "robert.palinsky@firstsource.com" },
  { name: "Richard Bryant", email: "micheal.bryant@firstsource.com" },
  {
    name: "Robert Delvecchio Petrucelli",
    email: "rob.petrucelli@firstsource.com",
  },
  { name: "Nichola Smith", email: "nichola.smith@ascensos.com" },
  { name: "Lyle McLean", email: "lyle.mclean@ascensos.com" },
  { name: "Noel Carbutt", email: "noel.carbutt@ascensos.com" },
  { name: "Shubham Choudhary", email: "shubham.choudhury@firstsource.com" },
  {
    name: "Srinivasan Subramanian",
    email: "srinivasan.subramanian@firstsource.com",
  },
  { name: "Sudha Bhat", email: "sudha.bhat@firstsource.com" },
  { name: "Sayed Ali Sharafudeen", email: "sayed.sharafudeen@firstsource.com" },
  { name: "Jeeshu Ganguly", email: "jeeshu.ganguly@firstsource.com" },
  { name: "Seshadri Narayanan", email: "seshadri.narayanan@firstsource.com" },
  { name: "Bidisha Sen", email: "bidisha.sen@firstsource.com" },
  { name: "Kelly Odenheimer", email: "kelly.odenheimer@firstsource.com" },
  { name: "Asim Burman", email: "#N/A" },
  { name: "Gagan Goel", email: "gagan.goel@firstsource.com" },
  { name: "MANIKANDA MURTHY B", email: "mani.bala@firstsource.com" },
  { name: "Robert Wolly", email: "robert.wolly@firstsource.com" },
  { name: "NANDAKUMAR R", email: "nandakumar.rajendran@firstsource.com" },
  { name: "Akshay Shinde", email: "akshay.shinde@firstsource.com" },
  { name: "Pooja Nambiar", email: "pooja.nambiar@firstsource.com" },
  { name: "Zainul Rizvi", email: "zainul.rizvi@firstsource.com" },
  { name: "Hanum Merchant", email: "hanum.merchant@firstsource.com" },
  { name: "Darius Vakil", email: "darius.v@firstsource.com" },
  { name: "Miestalin J", email: "miestalin.john@firstsource.com" },
  { name: "Marc Gerard Jison", email: "marcgerard.jison@firstsource.com" },
  { name: "Kirti Sinha", email: "kirti.sinha@firstsource.com" },
  { name: "Marie Sandler", email: "marie.sandler@firstsource.com" },
  {
    name: "Anandha Natarajan Vellapandian",
    email: "anandha.vellapandian@firstsource.com",
  },
  { name: "Sameer Kaushik", email: "sameer.kaushik@firstsource.com" },
  { name: "Ajay babu Chembula", email: "ajay.chembula@firstsource.com" },
  { name: "Chetan Karthik", email: "chetan.karthik@firstsource.com" },
  { name: "Dinesh Ramesh", email: "dinesh.ramesh@firstsource.com" },
  { name: "Venugopal Mudhaliar", email: "venugopal.mudhaliar@firstsource.com" },
  { name: "Vivek Saraiya", email: "vivek.saraiya@firstsource.com" },
  { name: "Saurabh Singh", email: "saurabh.singh2@firstsource.com" },
  { name: "Neil Ackinclose", email: "neil.ackinclose@firstsource.com" },
  { name: "Raghupathy N", email: "raghupathy.n@firstsource.com" },
  { name: "Ramesh Sambathkumar", email: "ramesh.sambathkumar@firstsource.com" },
  { name: "Pranesh Raj", email: "pranesh.raj@firstsource.com" },
  { name: "Daniel Wiernicki", email: "dan.wiernicki@firstsource.com" },
  {
    name: "Satheesh Nagasubramanian",
    email: "satheesh.nagasubramanian@firstsource.com",
  },
  { name: "Jayalakshmi Sriram", email: "jayalakshmi.sriram@firstsource.com" },
  { name: "Sheetu Ahuja", email: "sheetu.ahuja@firstsource.com" },
  { name: "Kshitij Varma", email: "kshitij.varma@firstsource.com" },
  {
    name: "Rajat Raghav Gopalakrishnan",
    email: "rajat.gopalakrishnan@firstsource.com",
  },
  {
    name: "Rajasekaran Padmanaban",
    email: "rajasekaran.padmanaban@firstsource.com",
  },
  { name: "Prashant Attri", email: "prashant.attri@firstsource.com" },
  { name: "Namrata Prakash", email: "namrata.prakash@firstsource.com" },
  { name: "Puran Prakash Pandey", email: "puran.pandey@firstsource.com" },
  { name: "Kapil Bobde", email: "kapil.bobde@firstsource.com" },
  {
    name: "Kalpita Bhattacharjee",
    email: "kalpita.bhattacharjee@firstsource.com",
  },
  { name: "Gurjeet Singh", email: "gurjeet.singh1@firstsource.com" },
  { name: "Sridhar Gunardhanan", email: "sridhar.gunardhanan@firstsource.com" },
  { name: "Ashish Ambulgekar", email: "ashish.ambulgekar@firstsource.com" },
  { name: "Anjali Nangalia", email: "anjali.nangalia@firstsource.com" },
  { name: "Madhumita Phukan", email: "madhumita.phukan@firstsource.com" },
  { name: "Dikshit Rawat", email: "dikshit.rawat@firstsource.com" },
  { name: "Bhavya Kalsi", email: "bhavya.kalsi@firstsource.com" },
  { name: "Vishal Vikas Deshmukh", email: "vishal.deshmukh@firstsource.com" },
  { name: "Arasu M", email: "arasu.moorthy@firstsource.com" },
  { name: "Chaitanya Kotakonda", email: "chaitanya.kotakonda@firstsource.com" },
  { name: "Reshma Nanjappa", email: "reshma.nanjappa@firstsource.com" },
  { name: "Ajay Devadas Prabhu", email: "ajay.prabhu@firstsource.com" },
  { name: "Amit Rao", email: "amit.rao@firstsource.com" },
  { name: "Satyan Diddi", email: "satyan.diddi@firstsource.com" },
  { name: "Ruchit Khanna", email: "ruchit.khanna@firstsource.com" },
  { name: "Sonali Gupta", email: "sonali.gupta2@firstsource.com" },
  {
    name: "Sailendranath Kasavajjhula",
    email: "sailendranath.kasavajjhula@firstsource.com",
  },
  { name: "Jayesh Nagda", email: "jayesh.nagda@firstsource.com" },
  { name: "Ashish Kumar Harode", email: "ashishkumar.harode@firstsource.com" },
  { name: "Harshad Borkar", email: "harshad.borkar@firstsource.com" },
  { name: "Azeezulla Sheriff M", email: "azeezulla.sheriff@firstsource.com" },
  { name: "Vipin V K", email: "vipin.vk@firstsource.com" },
  { name: "Asha Monnappa", email: "asha.monappa@firstsource.com" },
  { name: "Sunil Koshy M", email: "sunilk@firstsource.com" },
  {
    name: "Sudhindra Nagaraj Kakade",
    email: "sudhindra.kakade@firstsource.com",
  },
  { name: "Kimberly Buntyn", email: "kim.buntyn@firstsource.com" },
  { name: "Ravi N", email: "ravi.n@firstsource.com" },
  { name: "Purushotham C", email: "purushotham.c@firstsource.com" },
  { name: "Ishmel K Daniels", email: "ishmel.daniels@firstsource.com" },
  { name: "Amy L Debon", email: "amy.debon@firstsource.com" },
  { name: "Gnanasekar A", email: "gnanasekar.arumugam@firstsource.com" },
  { name: "Sasi Kumar D", email: "sasikumar.durai@firstsource.com" },
  { name: "Lisa C Lavista", email: "lisa.lavista2@firstsource.com" },
  {
    name: "Srinivasan Balasubramanian",
    email: "srinivasan.balasubramanian@firstsource.com",
  },
  { name: "Neelesh Shrivastava", email: "neelesh.shrivastava@firstsource.com" },
  { name: "Vishal Suresh Shukla", email: "vishal.shukla@firstsource.com" },
  { name: "Lakshmi Narayanan G", email: "lakshmi.narayanan@firstsource.com" },
  { name: "Arvinda Kumar H S", email: "arvinda.kumar@firstsource.com" },
  { name: "Kate Neilson", email: "kate.neilson2@firstsource.com" },
  { name: "Sankar Nagarajan", email: "sankar.nagarajan@firstsource.com" },
  { name: "Bert P. Kellerman", email: "bert.kellerman@firstsource.com" },
  { name: "Cynthia Y Diaz", email: "cynthia.diaz@firstsource.com" },
  { name: "Melissa Masterson", email: "melissa.masterson@firstsource.com" },
  { name: "Julie K Fischer", email: "julie.fischer@firstsource.com" },
  { name: "Jenna Rose Thorne Slezak", email: "jenna.thorne@firstsource.com" },
  {
    name: "Jerome Benjamin Alban Jeyakumar",
    email: "jerome.benjamin@firstsource.com",
  },
  {
    name: "Srihari Swetharanyam",
    email: "srihari.swetharanyam@firstsource.com",
  },
  { name: "Anurag Yadav", email: "anurag.yadav1@firstsource.com" },
  { name: "Rachael Ann Miller", email: "rachael.miller@firstsource.com" },
  { name: "Ankur Tandon", email: "ankur.tandon@firstsource.com" },
  { name: "Sonali Sen", email: "sonali.sen@firstsource.com" },
  { name: "Tara Marie Rose", email: "tara.rose@firstsource.com" },
  { name: "Brandon D Gervase", email: "brandon.gervase@firstsource.com" },
  { name: "Aaron Robinson", email: "aaron.robinson1@firstsource.com" },
  { name: "Steven Magilton", email: "steven.magilton@ascensos.com" },
  { name: "Regina J Thornburg", email: "regina.jones@firstsource.com" },
  { name: "Adam Milewski", email: "adam.milewski@firstsource.com" },
  { name: "Jason Hamilton", email: "jason.hamilton1@firstsource.com" },
  { name: "Chris S Gallagher", email: "chris.gallagher1@firstsource.com" },
  { name: "Daniel W Whitmore", email: "daniel.whitmore@firstsource.com" },
  { name: "Ryan Steven Cabral", email: "ryan.cabral@firstsource.com" },
  { name: "Laura M Rosado", email: "laura.rosado@firstsource.com" },
  {
    name: "Krystal Angelica Keys-merritt",
    email: "krystal.keysmerritt@firstsource.com",
  },
  {
    name: "Giselle Adriana Martinez",
    email: "giselle.martinez@firstsource.com",
  },
  { name: "Kevin Christopher Buck", email: "kevin.buck@firstsource.com" },
  { name: "Joseph E Frank", email: "joe.frank@firstsource.com" },
  { name: "Srinivas Kuthadi", email: "srinivas.kuthadi@firstsource.com" },
  { name: "Kelly Winters", email: "kelly.winters@firstsource.com" },
  { name: "Bahjat Nabill Nassar", email: "bahjat.nassar@firstsource.com" },
  { name: "Laura Rizzo", email: "laura.rizzo@firstsource.com" },
  {
    name: "Tiffany Shante Sturdivant",
    email: "tiffany.sturdivant@firstsource.com",
  },
  { name: "Jamie Lynn Watson", email: "jamie.watson1@firstsource.com" },
  { name: "Cynthia M Davila Vellon", email: "cynthia.davila@firstsource.com" },
  { name: "Karen Curtis", email: "karen.stewart@firstsource.com" },
  { name: "Priscilla Jean Medina", email: "priscilla.medina@firstsource.com" },
  { name: "Ravikiran Vadlamani", email: "ravikiran.vadlamani@firstsource.com" },
  { name: "Andrea Johnson Cooling", email: "andrea.cooling@firstsource.com" },
  { name: "Yash Vaghani", email: "yash.vaghani@firstsource.com" },
  { name: "Luis Eduardo Gomez Anaya", email: "luis.gomez@firstsource.com" },
  { name: "Selena R. Castle", email: "selena.castle@firstsource.com" },
  {
    name: "Jenessa Chanel Heckathorne",
    email: "jenessa.heckathorne@firstsource.com",
  },
  { name: "David M Gillpatrick", email: "mike.gillpatrick@firstsource.com" },
  { name: "Sharon Lynn Vanness", email: "sharon.vanness1@firstsource.com" },
  { name: "Rebecca Rosenberg", email: "rebecca.rosenberg@firstsource.com" },
  { name: "Linda Batten", email: "linda.batten@firstsource.com" },
  { name: "Kathleen Ehrmann", email: "kathleen.ehrmann@firstsource.com" },
  { name: "Jennifer Mendoza", email: "jennifer.mendoza@firstsource.com" },
  { name: "Vasudeo Ingale P", email: "vasudeo.i@firstsource.com" },
  { name: "Aveen Boardman", email: "aveen.boardman@firstsource.com" },
  { name: "Hiren Shah", email: "hiren.shah1@firstsource.com" },
  { name: "Kandida Lei Burns", email: "kandida.burns@firstsource.com" },
  { name: "Fintan Quinn", email: "fintan.quinn@firstsource.com" },
  { name: "Will Mcvicker", email: "william.mcvicker@firstsource.com" },
  { name: "Priyanka Mukherjee", email: "priyanka.mukherjee@firstsource.com" },
  { name: "Olivia F Devore", email: "oleevia.devore@firstsource.com" },
  { name: "Mansi gaur", email: "mansi.gaur@firstsource.com" },
  { name: "Akash Anand", email: "akash.anand@firstsource.com" },
  { name: "Manuel E Rodriguez", email: "manny.rodriguez@firstsource.com" },
  { name: "Travis L Cottrell", email: "travis.cottrell@firstsource.com" },
  { name: "Chelsea M Stansell", email: "chelsea.stansell@firstsource.com" },
  { name: "Swathi B", email: "swathi.balasubramanian@firstsource.com" },
  {
    name: "Govindarajulu S",
    email: "govindarajulu.subramanyam@firstsource.com",
  },
  { name: "Sharon L. David", email: "sharon.david@firstsource.com" },
  { name: "Donna L Rowe", email: "donna.rowe@firstsource.com" },
  { name: "Angela M Koski", email: "angela.koski@firstsource.com" },
  { name: "Michael Fischer", email: "michael.fischer1@firstsource.com" },
  { name: "Robert A Herrera", email: "robert.herrera1@firstsource.com" },
  { name: "William D Hillman", email: "william.hillman@firstsource.com" },
  { name: "Shobha Elizabeth K", email: "shobha.elizabeth@firstsource.com" },
  { name: "Naga Lakshmi V", email: "nagalakshmi.v@firstsource.com" },
  { name: "Baskar Dhamodharan", email: "baskar.dhamodharan@firstsource.com" },
  { name: "Unni Krishnan M G", email: "unni.krishnan@firstsource.com" },
  { name: "Lisa Aileen Hancovsky", email: "lisa.hancovsky@firstsource.com" },
  { name: "Jason Burgess", email: "jason.burgess@firstsource.com" },
  { name: "Syed Shiraz Hussain", email: "shiraz.hussain@firstsource.com" },
  { name: "Mahesh Kumar M", email: "kumar.mahesh@firstsource.com" },
  { name: "Namitha Mukundan", email: "namitha.mukundan@firstsource.com" },
  { name: "Pradeep Sasidharan", email: "pradeep.sasidharan@firstsource.com" },
  { name: "Steven Peterson", email: "steven.peterson@firstsource.com" },
  { name: "Sudhir Patni", email: "sudhir.patni@firstsource.com" },
  { name: "Debajyoti Ghosh Roy", email: "debajyoti.ghoshroy@firstsource.com" },
  { name: "Rahul Singh", email: "rahul.singh9@firstsource.com" },
  { name: "Yagnesh Mayani", email: "yagnesh.mayani@firstsource.com" },
  { name: "Rakesh Murlidharan Nair", email: "rakesh.nair@firstsource.com" },
  { name: "Karthik E", email: "karthik.e@firstsource.com" },
  { name: "Rizvi Ahmed White", email: "rizvi.ahmed@firstsource.com" },
  { name: "Ryan Lee White", email: "ryan.white@firstsource.com" },
  { name: "Bhavesh Tilawat", email: "bhavesh.tilawat@firstsource.com" },
  { name: "Margaret Davies", email: "margaret.davies@firstsource.com" },
  { name: "Avik Kumar Sarkar", email: "avik.sarkar@firstsource.com" },
  {
    name: "Neelakantan Venkitachalam",
    email: "neelakantan.venkitachalam@firstsource.com",
  },
  { name: "Aseem Kansal", email: "aseem.kansal@firstsource.com" },
  { name: "Moumita Goswami Patil", email: "moumita.patil@firstsource.com" },
  { name: "Bhaskar P", email: "bhaskar.ramanaiah@firstsource.com" },
  { name: "Siddharth Das", email: "siddharth.das@firstsource.com" },
  { name: "Sudha Singh", email: "sudha.singh@firstsource.com" },
  { name: "Ashutosh Dongare", email: "ashutosh.dongare@firstsource.com" },
  { name: "Mark Jackson", email: "mark.jackson@ascensos.com" },
  { name: "Akhil Muralidharan Lekha", email: "akhil.lekha@firstsource.com" },
  { name: "Nitin Mathur", email: "nitin.mathur@firstsource.com" },
  { name: "aparnendu upmanyu", email: "aparnendu.upmanyu1@firstsource.com" },
  { name: "Saravanan Durai", email: "saravanan.durai@firstsource.com" },
  {
    name: "Rajesh Prabhu Balakrishnan",
    email: "rajeshprabhu.balakrishnan@firstsource.com",
  },
  { name: "Daniel Ladewig", email: "dan.ladewig@firstsource.com" },
  { name: "Bernard Mcphee", email: "bernard.mcphee@ascensos.com" },
  { name: "Kim Canning", email: "kim.canning@ascensos.com" },
  { name: "Daniel Murphy", email: "daniel.murphy@ascensos.com" },
  { name: "Nicole Greenan", email: "nicole.greenan@ascensos.com" },
  { name: "Vivek Ganesh", email: "vivek.ganesh@firstsource.com" },
  { name: "Sekar R", email: "sekar.rangaswamy@firstsource.com" },
  { name: "Raghavan Jv", email: "raghavan.janakiraman@firstsource.com" },
  { name: "Shailaja Sundaresh", email: "shailaja.sundaresh@firstsource.com" },
  { name: "Dharmanand Pandey", email: "dharmanand.pandey@firstsource.com" },
  { name: "Ankush Malik", email: "ankush.malik@firstsource.com" },
  {
    name: "Satheeshbabu Kuppusamy",
    email: "satheeshbabu.kuppusamy@firstsource.com",
  },
  { name: "Geetha Lakshmi", email: "geetha.lakshmi1@firstsource.com" },
  {
    name: "Vishnupanthula Sravan Kumar",
    email: "sravan.kumar2@firstsource.com",
  },
  {
    name: "Narasimha Rao Mantripragada",
    email: "narasimharao.mantripragada@firstsource.com",
  },
  { name: "Nitesh Kumar Dubey", email: "nitesh.dubey@firstsource.com" },
  { name: "Raghavendra Papetla", email: "raghavendra.papetla@firstsource.com" },
  { name: "Jyoti Ranjan Panda", email: "jyotiranjan.panda1@firstsource.com" },
  {
    name: "Maria Maureen Du Manuel",
    email: "mariamaureen.manuel@firstsource.com",
  },
  { name: "Kura Manjunath", email: "kura.manjunath@firstsource.com" },
  { name: "Kevin Pinto", email: "kevinp@firstsource.com" },
  { name: "Eesha Mandra Kundu", email: "eesha.kundu@firstsource.com" },
  { name: "Siddeshwar J", email: "siddeshwar.joganna@firstsource.com" },
  { name: "Dilip P George", email: "dilip.george@firstsource.com" },
  {
    name: "Karthik Chakravarthy",
    email: "karthik.chakravarthy@firstsource.com",
  },
  { name: "Kartigan Munuswamy", email: "kartigan.munuswamy@firstsource.com" },
  { name: "Etesh Shetty", email: "etesh.shetty@firstsource.com" },
  { name: "Sampath Kumar", email: "sampath.kumar@firstsource.com" },
  { name: "Vaseem I Shaikh", email: "vaseem.shaikh@firstsource.com" },
  {
    name: "Gowrishankar Subramanian",
    email: "gowrishankar.subramanian@firstsource.com",
  },
  { name: "Prabhu Chellappan", email: "prabhu.c@firstsource.com" },
  { name: "Chandrima Banerjee", email: "chandrima.banerjee@firstsource.com" },
  { name: "Pravin Salunkhe", email: "pravin.salunkhe@firstsource.com" },
  { name: "Nithya Subramanian", email: "nithya.subramanian1@firstsource.com" },
  {
    name: "Raghu Krishna Yapalparvi",
    email: "raghu.yapalparvi@firstsource.com",
  },
  {
    name: "Kathiravan Subramanian",
    email: "kathiravan.subramanian@firstsource.com",
  },
  { name: "Manimaran Krishnan", email: "manimaran.krishnan@firstsource.com" },
  { name: "Mahendra Karera", email: "mahendra.karera@firstsource.com" },
  { name: "Ajay Patta", email: "ajay.patta@firstsource.com" },
  { name: "Sivakumar Kuppurao", email: "sivakumar.kuppurao@firstsource.com" },
  { name: "Pooja Trehan", email: "pooja.heda@firstsource.com" },
  { name: "Sanjay Kumar Dey", email: "sanjay.dey@firstsource.com" },
  {
    name: "Selvakumar Panneerselvam",
    email: "selvakumar.panneerselvam@firstsource.com",
  },
  { name: "Suhas Bhaskar Kk", email: "suhas.bhaskar@firstsource.com" },
  { name: "Balasubramani Raj", email: "balasubramani.raj@firstsource.com" },
  {
    name: "Subaashbaabu Krishnanbothi",
    email: "subaashbaabu.krishnanbothi@firstsource.com",
  },
  { name: "Saikumar Talla", email: "saikumar.talla@firstsource.com" },
  { name: "Brijesh Galgate", email: "brijesh.galgate1@firstsource.com" },
  { name: "Ashok Varadarajan", email: "ashok.varadarajan@firstsource.com" },
  {
    name: "Mohamed Rafeek Ali V.m.",
    email: "mohamed.rafeekalivm@firstsource.com",
  },
  {
    name: "John Anthony Enecio Misa",
    email: "johnanthony.misa@firstsource.com",
  },
  {
    name: "Philip Emmanuel P. Commeyne",
    email: "philipemmanuel.commeyne@firstsource.com",
  },
  { name: "Carolyn Lowe", email: "carolyn.lowe@firstsource.com" },
  { name: "Deepali Verdi", email: "deepali.verdi@firstsource.com" },
  { name: "Leena Honnaya Pujari", email: "leena.pujari@firstsource.com" },
  {
    name: "Sriram Muthukrishnan",
    email: "sriram.muthukrishnan@firstsource.com",
  },
  {
    name: "Dhawal Shrikant Potkatare",
    email: "dhawal.potkatare@firstsource.com",
  },
  { name: "Sunil Seth", email: "sunil.seth@firstsource.com" },
  { name: "Ravie Chander N", email: "raviechander.nnn@firstsource.com" },
  { name: "Sherine N", email: "sherine.moses@firstsource.com" },
  { name: "Monika Misra", email: "monika.misra@firstsource.com" },
  { name: "N S R K Pavan Kumar", email: "nsrk.pavankumar@firstsource.com" },
  {
    name: "Srinivasa Bharaneetharan Sampath Kumar",
    email: "srinivasabharaneetharan.sampathkumar@firstsource.com",
  },
  { name: "Marrion Samson", email: "marrion.samson@firstsource.com" },
  { name: "Malavika S L Gowda", email: "malavika.gowda@firstsource.com" },
  { name: "Syed Shah Habeeb Ali", email: "syed.ali7@firstsource.com" },
  { name: "Tashua R Cecil", email: "tashua.curtis@firstsource.com" },
  { name: "Shridhar A Awate", email: "shridhar.awate@firstsource.com" },
  {
    name: "Joyce Fe Migrino Casenas",
    email: "joycefe.casenas@firstsource.com",
  },
  { name: "Mohanraj P", email: "mohanraj.ppp1@firstsource.com" },
  { name: "Sumit Agarwal", email: "sumit.agarwal1@firstsource.com" },
  { name: "Bharat Kaushik", email: "bharat.kaushik@firstsource.com" },
  { name: "Aditi Bhandari", email: "aditi.bhandari@firstsource.com" },
  { name: "Sooraj Divakaran", email: "sooraj.divakaran@firstsource.com" },
  {
    name: "Praveen Kumar Gudalore",
    email: "praveenkumar.gudalore@firstsource.com",
  },
  { name: "Kaizad Shapur Debu", email: "kaizad.debu@firstsource.com" },
  { name: "Thi My-hanh Do", email: "thi.myhanhdo@firstsource.com" },
  { name: "Rahul Sovani", email: "rahul.sovani@firstsource.com" },
  { name: "Ragesh R", email: "ragesh.raju@firstsource.com" },
  { name: "Amol Bhagwan Raikar", email: "amol.raikar@firstsource.com" },
  { name: "Gcobisa Nosilela", email: "gcobisa.nosilela@ascensos.com" },
  { name: "Soumyadipta Biswas", email: "soumyadipta.biswas@firstsource.com" },
  {
    name: "Surya Leena Praveen Nallari",
    email: "praveen.nallari@firstsource.com",
  },
  { name: "Abhishek Rajesh Behl", email: "abhishek.behl@firstsource.com" },
  { name: "Aravind N R", email: "aravind.ntt@firstsource.com" },
  { name: "Sai Kiran Uppala", email: "saikiran.uppala@firstsource.com" },
  { name: "Suraj Mittal", email: "suraj.mittal@firstsource.com" },
  { name: "Kelly Fox", email: "kelly.fox@firstsource.com" },
  {
    name: "Sidhanta Satyabrata Nayak",
    email: "sidhanta.nayak@firstsource.com",
  },
  {
    name: "Joseph Robert Steinbronn",
    email: "joseph.steinbronn@firstsource.com",
  },
  { name: "Vaishali Pandya", email: "vaishali.pandya@firstsource.com" },
  { name: "KarishmaN Shah", email: "karishma.shah@firstsource.com" },
  {
    name: "Umamaheshwar Sirigey",
    email: "umamaheshwar.sirigey1@firstsource.com",
  },
  { name: "Mumal Singhvi", email: "mumal.singhvi@firstsource.com" },
  { name: "Sohini Sarkar", email: "sohini.sarkar1@firstsource.com" },
  { name: "Vineeth Kumar", email: "vineeth.kumar1@firstsource.com" },
  { name: "Hariharan Raja", email: "hariharan.raja2@firstsource.com" },
  { name: "Test1", email: "test1@test.com" },
  { name: "Test2", email: "test2@test.com" },
  { name: "Test3", email: "test3@test.com" },
  { name: "Test4", email: "test4@test.com" },
]

export const AUTHORIZED_EMAILS = AUTHORIZED_USERS.map(user => user.email)
  .filter(email => typeof email === "string" && email.includes("@"))
  .map(email => email.trim().toLowerCase())

export const findAuthorizedUser = email =>
  AUTHORIZED_USERS.find(
    user => user.email.trim().toLowerCase() === email?.trim().toLowerCase()
  )

export const isAuthorizedEmail = email =>
  AUTHORIZED_EMAILS.includes(email?.trim().toLowerCase())
